import React,{ Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import ReactSelect from 'react-select'
import { connect } from 'react-redux';
import mySectionsData from '../helpers/MySectionsData';

import SectionItem from './SectionItem';
import MySectionItem from './MySectionItem';

class MySection extends Component {

    constructor(props){
        super(props);

        this.getMySection = this.getMySection.bind(this)

        this.state = {
            loading: true,
            saveElements : mySectionsData.getAllSections(),
        }
    }



    componentWillMount(){
        mySectionsData.on('change', this.getMySection)
    }

    componentDidMount(){
        var request = {
            'option' : 'com_sppagebuilder',
            'task' : 'page.getMySections',
        };

        jQuery.ajax({
            type   : 'POST',
            data   : request,
            dataType: 'json',
            success: (response) => {
                mySectionsData.setAllSections(response);

                this.setState({
                    loading: false
                })
            }
        });
    }

    componentWillUnmount(){
        mySectionsData.removeListener('change', this.getMySection);
    }

    getMySection(){
        this.setState({
            saveElements: mySectionsData.getAllSections()
        })
    }

    render(){
        return(
            <div className="sp-pagebuilder-my-section-lib-panel">
                {
                    (this.state.loading && !this.state.saveElements.length)
                    ?
                    <div className="sppb-sections-loader">
                        <i className="fa fa-circle-o-notch fa-spin"></i>
                        One moment please...
                    </div>
                    :
                    ''
                }
                {
                    this.state.saveElements.length
                    ?
                    <ul>
                        {

                            this.state.saveElements.map((element, index) => {
                                return(
                                    <MySectionItem element={element} key={index} index={index} />
                                )
                            })
                        }
                    </ul>
                    :
                    ''
                }

                {
                    !this.state.loading && !this.state.saveElements.length
                    ?
                    <div style={{
                        padding: '10px',
                        textAlign: 'center',
                        background: '#fcf8e3',
                        marginTop: '10px',
                        borderRadius: '3px',
                        color: '#8A6D37'
                    }}>There is no saved section found.</div>
                    :
                    ''
                }


            </div>
        )
    }
}

export default connect()(MySection);



// WEBPACK FOOTER //
// ./src/components/MySection.js